module.exports = __webpack_public_path__ + "img/logo_vertical_colorido.34aaf0f9.jpg";